import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext } from "../../context/LanguageContext";
import { GERMAN } from "../../actions/language";
import {
    OFFICE_CONTACT_EMAIL,
    OFFICE_CONTACT_OFFICE_PHONE_NUMBER
} from "../../env";

const CtaBand = () => {
    const { language } = useContext(LanguageContext);
    const de = language === GERMAN;

    return (
        <section className="tm-cta">
            <div className="tm-cta__inner">
                <div>
                    <span className="tm-eyebrow">
                        {de ? 'Bereit für den nächsten Schritt?' : 'Pronto para o próximo passo?'}
                    </span>
                    <h2 className="tm-cta__title">
                        {de
                            ? <span>Sprechen wir über <em>Ihr Anliegen</em>.</span>
                            : <span>Vamos falar sobre <em>o seu projeto</em>.</span>}
                    </h2>
                    <p className="tm-cta__text">
                        {de
                            ? 'Ein erstes Gespräch ist unverbindlich und kostenlos. Schildern Sie uns Ihre Situation – wir sagen Ihnen ehrlich, wie wir Sie entlasten können.'
                            : 'Uma primeira conversa é gratuita e sem compromisso. Descreva-nos a sua situação – diremos com honestidade como o podemos apoiar.'}
                    </p>
                </div>
                <div className="tm-cta__actions">
                    <Link to="/contact/" className="tm-btn tm-btn--primary">
                        <i className="fas fa-comments"/>
                        {de ? 'Kontakt aufnehmen' : 'Contactar-nos'}
                    </Link>
                    <a href={'mailto:' + OFFICE_CONTACT_EMAIL} className="tm-btn tm-btn--ghost">
                        <i className="fas fa-envelope"/>
                        {de ? 'E-Mail schreiben' : 'Escrever e-mail'}
                    </a>
                    <div className="tm-cta__contact">
                        <span>
                            {de ? 'Oder rufen Sie direkt an:' : 'Ou ligue diretamente:'}
                        </span>
                        <a href="tel:+4961357044080">{OFFICE_CONTACT_OFFICE_PHONE_NUMBER}</a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CtaBand;



// WEBPACK FOOTER //
// ./src/components/common/CtaBand.js